import {
  AlarmClock,
  Bell,
  FileSignature,
  Heart,
  LifeBuoy,
  MessageSquare,
  Sparkles,
  Tag,
  type LucideIcon,
} from "lucide-react";

export type Notification = {
  id: string;
  type: string;
  title: string;
  body: string | null;
  link: string | null;
  is_read: boolean;
  created_at: string;
};

export type NotificationList = {
  items: Notification[];
  unread_count: number;
};

/** Bell / popup icon per notification type (kept in sync with the backend TYPE_* constants). */
const TYPE_ICON: Record<string, LucideIcon> = {
  interest_reply: MessageSquare,
  new_interest: Heart,
  new_listing: Sparkles,
  support_response: LifeBuoy,
  listing_change: Tag,
  nda_request: FileSignature,
  interest_escalation: AlarmClock,
};

export function iconFor(type: string): LucideIcon {
  return TYPE_ICON[type] ?? Bell;
}

export function timeAgo(iso: string): string {
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return "";
  const diff = Math.max(0, Date.now() - then);
  const mins = Math.floor(diff / 60_000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  if (days < 7) return `${days}d ago`;
  return new Date(iso).toLocaleDateString();
}
